import { Component,  OnDestroy,  OnInit } from '@angular/core';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { TranslationEntryObject } from '@app/shared/models/translatable';
import { CaseSetting, CaseSettings } from '@app/shared/models/case-settings';

@Component({
    templateUrl:  './case-settings-management.component.html',
    styleUrls:  ['./case-settings-management.component.scss']
})
export class CaseSettingsManagementComponent extends BaseWithBundleComponent
                                           implements OnInit,  OnDestroy {

    public caseSettings: TranslationEntryObject[];
    public selected: TranslationEntryObject;

    get CaseSetting() {
        return CaseSetting;
    }

    constructor(protected componentServiceBundle:  ComponentServiceBundle) {
        super(componentServiceBundle);
        this._idPrefix = 'settings-case-settings-management.';
        this.caseSettings = CaseSettings.ALL_AS_TRANSLATION_ENTRY_OBJECTS;
    }

    public ngOnInit() {
        super.ngOnInit();
        this.select(this.caseSettings[0]);
    }

    public ngOnDestroy() {
        super.ngOnDestroy();
    }

    public select(caseSettings: TranslationEntryObject): void {
        this.selected = caseSettings;
    }

}
